export const getDocument = (arr, kind) => arr.find((doc) => doc.kind === kind);
